import styled from 'styled-components';
import { colors } from 'stylesheets';

export const OrderCard = styled.div`
  width: 98%;
  min-height: 450px;
  border: 1px solid ${colors.greyLighter};
  border-radius: 2px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  margin: 0px auto 10px;
  display: flex;
  flex-direction: column;
  opacity: ${({ canceled }) => (canceled ? 0.5 : 1)};
  pointer-events: ${({ canceled }) => (canceled ? 'none' : 'auto')};
`;

export const ContentTab = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Container = styled.div`
  padding-top: 12%;
  margin: 0 auto;
  p {
    text-transform: uppercase;
    font-size: 20px;
    text-align: center;
  }
`;
